<template>
  <div class="message-board page">
    <van-nav-bar :title="$t('my.sys_notice')" class="nav-bar" :border="false" />

    <div class="content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="notice-card" v-for="(v, key) in notice" :key="v.id || key">
          <div class="notice-meta">
            <div class="notice-date">{{ v.create_time }}</div>
            <div class="notice-no">{{ v.board_no }}</div>
          </div>
          <div class="notice-body">{{ v.content }}</div>
        </div>
        <van-empty
          v-if="!notice.length && !isLoading"
          :description="$t('withdraw.empty_data')"
        />
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      notice: [],
    }
  },
  methods: {
    getNoticeList() {
      this.$http({
        method: 'get',
        url: 'message_board_list',
      })
        .then((res) => {
          this.notice = res.data || []
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    onRefresh() {
      this.getNoticeList()
      this.$toast(this.$t('reservation.refresh'))
    },
  },
  created() {
    this.getNoticeList()
  },
}
</script>

<style lang="less" scoped>
.message-board {
  min-height: 100vh;
  background: #f2f3f5;
  padding-bottom: 16vw;
}

.nav-bar {
  background: #fff !important;

  /deep/ .van-nav-bar__title {
    color: #111;
    font-weight: 600;
  }
}

.content {
  padding: 3.2vw;
  box-sizing: border-box;
}

.notice-card {
  background: #fff;
  border-radius: 2.4vw;
  padding: 3.6vw 4vw;
  margin-bottom: 3.2vw;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
}

.notice-meta {
  margin-bottom: 2vw;
}

.notice-date {
  font-size: 3.2vw;
  color: #999;
  line-height: 1.4;
}

.notice-no {
  margin-top: 0.8vw;
  font-size: 8vw;
  line-height: 1;
  color: #d0d0d0;
  font-weight: 500;
}

.notice-body {
  font-size: 3.733vw;
  line-height: 1.65;
  color: #333;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
